import React, { useState, useEffect, useCallback } from 'react';
import './MobileProgressNavigator.css';

const SECTIONS = [
  { id: 'imt-track',          label: 'IMT-Track' },
  { id: 'calls-app',          label: 'iMatrix Calls' },
  { id: 'logistic',           label: 'iMatrix Logistic' },
  { id: 'e-ware',             label: 'e-Warehouse' },
  { id: 'voucher-approvals',  label: 'Voucher Approver' },
  { id: 'authenticator',      label: 'Boss-Key' },
];

const MobileProgressNavigator = () => {
  const [activeSection, setActiveSection] = useState('imt-track');
  const [scrollPct, setScrollPct] = useState(0);
  const [visible, setVisible] = useState(false);

  const handleScroll = useCallback(() => {
    const scrollTop  = window.scrollY;
    const docHeight  = document.documentElement.scrollHeight - window.innerHeight;
    const pct        = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    setScrollPct(pct);
    setVisible(scrollTop > 200);

    // Determine active section by scroll position
    let current = 'imt-track';
    for (const section of SECTIONS) {
      const el = document.getElementById(section.id);
      if (el) {
        const rect = el.getBoundingClientRect();
        // Trigger active when the top of section is in the middle of viewport
        if (rect.top <= window.innerHeight * 0.45) {
          current = section.id;
        }
      }
    }
    setActiveSection(current);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <nav
      className={`mobiledev-nav ${visible ? 'mobiledev-nav--visible' : ''}`}
      aria-label="Mobile projects section navigator"
    >
      {/* Vertical progress track */}
      <div className="mobiledev-nav__track">
        <div
          className="mobiledev-nav__progress"
          style={{ height: `${scrollPct}%` }}
          aria-hidden="true"
        />
      </div>

      {/* Section dots */}
      <ul className="mobiledev-nav__dots">
        {SECTIONS.map((s) => (
          <li key={s.id}>
            <button
              className={`mobiledev-nav__dot ${activeSection === s.id ? 'active' : ''}`}
              onClick={() => scrollTo(s.id)}
              aria-label={`Navigate to ${s.label}`}
              title={s.label}
            >
              <span className="mobiledev-nav__dot-inner" />
              <span className="mobiledev-nav__label">{s.label}</span>
            </button>
          </li>
        ))}
      </ul>

      {/* Scroll to top */}
      {scrollPct > 80 && (
        <button
          className="mobiledev-nav__top-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Scroll to top"
          title="Back to Top"
        >
          ↑
        </button>
      )}
    </nav>
  );
};

export default MobileProgressNavigator;
